import { render, staticRenderFns } from "./request.vue?vue&type=template&id=482f81e2&"
import script from "@/scripts/extraServiceRequest/request.js?vue&type=script&lang=js&"
export * from "@/scripts/extraServiceRequest/request.js?vue&type=script&lang=js&"
import style0 from "./request.vue?vue&type=style&index=0&id=482f81e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports